import { currentEpochNumber, formatCountdownTimer, secondsUntilNextEpoch } from "@/domains/library/dates"

const SECONDS_IN_WEEK = 7 * 86400

export interface EpochCountdownSnapshot {
  readonly epochNumber: number
  readonly countdownLabel: string
  readonly weekProgressPercent: number
}

export function computeEpochCountdownSnapshot(chainSlug: string, now = new Date()): EpochCountdownSnapshot {
  const epochNumber = currentEpochNumber({ chainSlug, date: now })
  const secondsUntilEpoch = secondsUntilNextEpoch(now)
  const countdownLabel = formatCountdownTimer(secondsUntilEpoch)
  const weekProgress = 1 - secondsUntilEpoch / SECONDS_IN_WEEK

  return {
    epochNumber,
    countdownLabel,
    weekProgressPercent: Math.round(weekProgress * 100),
  }
}
